<template>
  <div />
</template>

<script lang="ts" setup>
// import bridge from '@vkontakte/vk-bridge'
import { onBeforeMount } from 'vue'
import {
  type ConfigurationDTO,
  getParsedInitialParamsFromQuery,
  partnerKey
} from '@/5_entities/Configuration'
import { useLocation, type Location } from '@/5_entities/Location'
import { type UserDTO, type UserEncryptedParams, useUser } from '@/5_entities/User'

type PropType = {
  configuration: ConfigurationDTO
}
type EmitType = {
  (e: 'userInitialized'): void
}
type ParamsFromQuery = {
  strategy: 'encryptedParams' | 'userParams'
  data: UserDTO | UserEncryptedParams
}

const props = defineProps<PropType>()
const emit = defineEmits<EmitType>()

const { authUser, updateUserLocation } = useUser()

const { setLocationOnInit } = useLocation()

const getParamsFromQuery = (): ParamsFromQuery => {
  const query = getParsedInitialParamsFromQuery()

  if (query?.params) {
    return {
      strategy: 'encryptedParams',
      data: {
        params: query.params as string,
        partnerKey: partnerKey.get()
      }
    }
  }

  return {
    strategy: 'userParams',
    data: {
      userId: query.userId as string,
      birthYear: query?.birthYear && Number(query?.birthYear as string),
      sex: query?.sex,
      partnerKey: partnerKey.get(),
      cityId: query?.cityId && Number(query?.cityId as string)
    } as UserDTO
  }
}

//https://youtrack.intickets.ru/issue/A-1694/Shifrovanie.-V2
// /**
//  * проверяем, что открыты в vk Apps
//  */
// const checkIsVk = () => {
//   const query = getParsedInitialParamsFromQuery()
//
//   return 'isVk' in query
// }
//
// /**
//  * пытаемся заинтить вк
//  */
// const tryToInitVk = async (): Promise<boolean> => {
//   return new Promise((resolve, reject) => {
//     bridge
//       .send('VKWebAppInit')
//       .then(() => resolve(true))
//       .catch(() => reject(false))
//
//     setTimeout(() => reject(false), getMilliseconds.inSeconds(5))
//   })
// }
// /**
//  * пробуем получить email пользователя из vk API.
//  * если встроены не в Vk Apps и нам не запретелили
//  * @returns email:string | ''
//  */
// const tryToGetUserIdFromVkApp = async (): Promise<string> => {
//   return await bridge
//     .send('VKWebAppGetEmail')
//     .then((data) => (data?.email ? `userVk:${data.email}` : ''))
//     .catch(() => '')
// }

const setLocation = (userData: UserDTO) => {
  const { location, adjustLocation } = userData

  setLocationOnInit(location as Location, adjustLocation)
}

const needToOverrideUserCity = (userData: UserDTO) => {
  const { strategy, data: dataFromUrl } = getParamsFromQuery()

  if (strategy === 'encryptedParams') return false

  return (
    props.configuration?.canOverrideCity &&
    (dataFromUrl as UserDTO)?.cityId &&
    (dataFromUrl as UserDTO)?.cityId !== userData?.cityId
  )
}
/**
 * https://youtrack.intickets.ru/issue/A-1823/Poluchat-izmeneniya-cityId-ot-partnyora
 * перезаписывает location пользователя на тот,
 * который в ссылке принудительно, если
 * у партнера canOverrideCity и cityId не совпадают
 * @param userData
 */
const overrideUserCity = (userData: UserDTO): UserDTO => {
  const { strategy, data: dataFromUrl } = getParamsFromQuery()

  if (strategy === 'userParams' && needToOverrideUserCity(userData)) {
    return {
      ...userData,
      cityId: (dataFromUrl as UserDTO)?.cityId,
      location:
        props.configuration.locations.find(
          (item) => item.id === (dataFromUrl as UserDTO)?.cityId
        ) ?? props.configuration.defaultCity
    }
  }

  return userData
}

onBeforeMount(async () => {
  //https://youtrack.intickets.ru/issue/A-1694/Shifrovanie.-V2
  // const isVk = checkIsVk()
  // if (isVk) {
  //   const isVkInitialized = await tryToInitVk()
  //   const needToRequestVkUserEmail = isVkInitialized && !userDTO.userId
  //
  //   needToRequestVkUserEmail && (userDTO.userId = await tryToGetUserIdFromVkApp())
  // }

  const { strategy, data } = getParamsFromQuery()
  const cleanUserData = await authUser(data as UserEncryptedParams)

  if (!cleanUserData) return emit('userInitialized')

  switch (strategy) {
    case 'userParams':
      {
        const userData = overrideUserCity(cleanUserData)
        setLocation(userData)
        const needToUpdateLocation = needToOverrideUserCity(cleanUserData)
        needToUpdateLocation &&
          updateUserLocation(userData.location as Location, needToUpdateLocation)
      }
      break
    case 'encryptedParams': {
      setLocation(cleanUserData)
    }
  }

  emit('userInitialized')
})
</script>
